import PercentageButton from "./percentage-button";

interface PercentageButtonsProps {
  remainingTokens: number;
  tokenPrice: number;
  userPurchaseAssetBalance: number;
  onPercentageClick: (percentage: number) => void;
  purchaseAssetDecimalDenom: number;
  userMaxSpend: number;
}
const STANDARD_PERCENTAGES = [0.25, 0.5, 0.75];

export default function PercentageSelector({
  remainingTokens,
  tokenPrice,
  userPurchaseAssetBalance,
  onPercentageClick,
  purchaseAssetDecimalDenom,
}: PercentageButtonsProps) {
  const userBalance = userPurchaseAssetBalance / purchaseAssetDecimalDenom;

  const validPercentages = STANDARD_PERCENTAGES.filter((percentage) => {
    const paymentAmount = userBalance * percentage;
    const tokensUserCouldBuy = paymentAmount / tokenPrice;
    return tokensUserCouldBuy >= remainingTokens;
  });

  const buttons = validPercentages.map((percentage) => (
    <PercentageButton
      key={percentage}
      onClick={(e) => {
        e.preventDefault();
        onPercentageClick(percentage);
      }}
    >
      {`${percentage * 100}%`}
    </PercentageButton>
  ));

  if (userBalance > 0)
    buttons.push(
      <PercentageButton
        key="max"
        onClick={(e) => {
          e.preventDefault();
          onPercentageClick(1);
        }}
      >
        MAX
      </PercentageButton>
    );

  return buttons;
}
